// AUTO-GENERATED FILE. Do not edit.
import { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import { PokeType } from "types/pokemon/poke-type";

export const ferrothorn: PokeData = {
  "id": 598,
  "name": "ferrothorn",
  "height": 10,
  "weight": 1100,
  "base_experience": 171,
  "types": [
    PokeType.GRASS,
    PokeType.STEEL
  ],
  "api_moves": [
    "tackle",
    "pin-missile",
    "harden",
    "self-destruct",
    "explosion",
    "curse",
    "rollout",
    "metal-claw",
    "ingrain",
    "iron-defense",
    "gyro-ball",
    "payback",
    "mirror-shot",
    "flash-cannon",
    "rock-climb",
    "power-whip",
    "iron-head"
  ],
  "moves": [
    "tackle",
    "pin-missile",
    "curse",
    "metal-claw",
    "power-whip",
    "energy-ball",
    "vine-whip",
    "metal-sound",
    "magnet-pull",
    "smart-strike",
    "leaf-tornado",
    "magnet-bomb",
    "metal-burst"
  ],
  "evolution_chain": {
    "id": 304,
    "item": null,
    "species": [
      {
        "name": "ferroseed",
        "order": 598,
        "types": [
          PokeType.GRASS,
          PokeType.STEEL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "ferrothorn",
        "order": 599,
        "types": [
          PokeType.GRASS,
          PokeType.STEEL
        ],
        "evolves_from_species_id": 597,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 40,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 186,
    "speed": 38,
    "ability_power": 177
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
